import { useEffect, useRef } from 'react'
import { WidgetInstance } from 'friendly-challenge'
import { toast } from 'react-toastify'

export default function FriendlyCaptcha ({ onResponse }) {
  const container = useRef()
  const widget = useRef()

  const doneCallback = (solution) => {
    onResponse(solution)
  }

  const errorCallback = (err) => {
    toast.error(err)
  }

  useEffect(() => {
    if (!widget.current && container.current) {
      widget.current = new WidgetInstance(container.current, {
        startMode: 'auto',
        doneCallback,
        errorCallback
      })
    }

    return () => {
      if (widget.current !== undefined) widget.current.reset()
    }
  }, [container])

  return (
    <div ref={container}
      className="frc-captcha"
      data-sitekey={process.env.NEXT_PUBLIC_FRIENDLY_CAPTCHA_SITE_KEY}
    />
  )
}
